import Moment from 'moment-timezone';

function toLocalDate(value) {
    if (!value) {
        return;
    }

    const utcDate = Moment.utc(value);

    return utcDate.isValid && utcDate.local().format('MM/DD/YYYY');
}

function toLocalDateTime(value) {
    if (!value) {
        return;
    }

    const utcDate = Moment.utc(value);

    return utcDate.isValid && utcDate.local().format('MM/DD/YYYY h:mm A');
}

function toEasternDate(value) {
    if (!value) {
        return;
    }

    const utcDate = Moment.utc(value);

    return utcDate.isValid && utcDate.tz('America/New_York').format('MM/DD/YYYY [ET]');
}

function toEasternDateTime(value) {
    if (!value) {
        return;
    }

    const utcDate = Moment.utc(value);

    return utcDate.isValid && utcDate.tz('America/New_York').format('MM/DD/YYYY[\n]h:mm A [ET]');
}

export default {
    toLocalDate,
    toLocalDateTime,
    toEasternDate,
    toEasternDateTime
};
